import { SYS_COMPASS } from '@constants';
import type { SceneConfigCompass } from '@types';

export const COMPASS_DEFAULT: SceneConfigCompass = {
  enabled: 0,
  type: 0,
  mediaId: 0,
  mediaUrl: SYS_COMPASS[0].url,
  position: 'topleft',
};
